import React, { useCallback, useMemo, useState } from "react";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp_New_Iqama from "../../../../../ReusableComponents/UploadFile/uploadFileNewIqama";
import SmartDownloadPagination from "../../../../../components/SmartDataTable/SmartDownloadPagination";

export default function ListIqamaUpdateList({
  token,
  updateData,
  setDataLen,
  setIndex,
}) {
  const [Popup, setPopUp] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const columns = useMemo(() => [
    { key: "sno", title: "S.NO." },
    { key: "emp_id", title: "EMPLOYEE ID" },
    { key: "border_number", title: "BORDER NUMBER" },
    { key: "passport_number", title: "PASSPORT NUMBER" },
    { key: "visa_provider", title: "VISA PROVIDER" },
    { key: "sponsor_id", title: "SPONSOR ID" },
    { key: "iqama_number", title: "IQAMA NUMBER" },
    { key: "iqama_received_date", title: "IQAMA RECEIVED DATE" },
    { key: "iqama_issue_date", title: "IQAMA ISSUE DATE" },
    { key: "iqama_expiry_date_g", title: "IQAMA EXPIRY DATE (G)" },
    { key: "iqama_expiry_date_h", title: "IQAMA EXPIRY DATE (H)" },
    { key: "iqama_aging_days", title: "IQAMA AGEING DAYS" },
    { key: "iqama_valid_days", title: "IQAMA VALID DAYS" },
    { key: "iqama_status", title: "STATUS" },
  ], []);

  const handleStandaloneSearch = async (term) => {
    if (!term) return;
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await nodeinstance.get(`/iqama/getFilterByEmployeeId/${term}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && response.data.status) {
        setSearchData(response.data.data);
      }
    } catch (error) {
      dispatch(setAppError({ msg: "Search failed: " + error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setIsSearchActive(false);
      setSearchData(null);
    }
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(`/iqama/download?download=1`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Iqama.xlsx`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(setAppError({ msg: err.message }));
    } finally {
      setDownloadLoading(false);
    }
  };

  const apiCall = () => {
    setTrigger(prev => !prev);
    if (updateData) updateData();
    if (setIndex) setIndex(2);
  };

  const SuccessapiCall = () => {
    setTrigger(prev => !prev);
    if (updateData) updateData();
  };

  const handleDataLoad = useCallback((data) => {
    if (data && setDataLen) {
      const filteredData = data.filter(
        (indexData) => indexData.iqama_status === "Iqama Number Updated"
      );
      setDataLen(filteredData.length);
    }
  }, [setDataLen]);

  const additionalActions = useMemo(() => [
    {
      label: "Upload Iqama details",
      onClick: () => setPopUp(true),
      className: "p-2 px-4 rounded-md bg-blue text-white min-w-fit text-sm flex items-center gap-2"
    },
    {
      label: downloadLoading ? (
        <div className="flex gap-2 items-center">
          <span>Downloading</span>
          <CgSpinner className="animate-spin" />
        </div>
      ) : "Download",
      onClick: downloadFile,
      disabled: downloadLoading,
      className: "p-2 px-4 rounded-md bg-blue text-white min-w-fit text-sm flex items-center gap-2"
    }
  ], [downloadLoading]);

  return (
    <>
      <div className="mt-4">
        <SmartDownloadPagination
          apiEndpoint="/iqama"
          token={token}
          columns={columns}
          layoutType="table"
          additionalActions={additionalActions}
          searchPlaceholder={"Search employee id..."}
          defaultPageSize={50}
          pageSizeOptions={[10, 50, 100, 500, 1000]}
          onDataLoad={handleDataLoad}
          trigger={trigger}
          onSearchClick={handleStandaloneSearch}
          onSearchChange={handleSearchChange}
          manualData={isSearchActive ? searchData : null}
          enableDownload={false}
        />
      </div>

      {Popup && (
        <UploadFilePopUp_New_Iqama
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Iqama"}
          url={"/iqama/upload"}
          callBack={apiCall}
          SuccessapiCall={SuccessapiCall}
        />
      )}
    </>
  );
}
